export interface BrandImageAsset {
  readonly src: string;
  readonly alt: string;
  readonly width: number;
  readonly height: number;
}

export interface BrandAssets {
  readonly logo: BrandImageAsset;
  readonly logoDark: BrandImageAsset;
  readonly icon: BrandImageAsset;
  readonly openGraphImage: BrandImageAsset;
}

export const brandAssets: BrandAssets = {
  logo: {
    src: "/brand/logo.svg",
    alt: "Zzk Lens",
    width: 180,
    height: 48,
  },
  logoDark: {
    src: "/brand/logo-dark.svg",
    alt: "Zzk Lens",
    width: 180,
    height: 48,
  },
  icon: {
    src: "/brand/icon.svg",
    alt: "Zzk Lens icon",
    width: 48,
    height: 48,
  },
  openGraphImage: {
    src: "/brand/og-image.svg",
    alt: "Zzk Lens preview",
    width: 1200,
    height: 630,
  },
};
